module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/form-element/label-input/label-input.component.scss
// module id = ./src/app/features/form-element/label-input/label-input.component.scss
// module chunks = main